module.exports = __webpack_public_path__ + "front/img/c9.f2eb09e7.png";